// action
import {
    ACTIVATE_DOCTOR,
    ACTIVATE_DOCTOR_FAIL,
    ACTIVATE_DOCTOR_SUCCESS,
    ACTIVATE_DOCTOR_RESET
} from '../action/activateDoctorAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case ACTIVATE_DOCTOR:
            return {
                ...state,
                apiState: "loading"
            }
        case ACTIVATE_DOCTOR_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case ACTIVATE_DOCTOR_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case ACTIVATE_DOCTOR_RESET:
            return initialState
        default:
            return state
    }
}